// extracted by mini-css-extract-plugin
export var base = "_12-0";
export var updateBanner = "_12-1";